//-------------------------------------------------------------------------------------------------- Imports
import _ from "lodash";
import Loading from "../../../components/Loading";
import { Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ConfigurableService, ResponsePackageActivation } from "../../../types/common";
import { useState } from "react";
import InfoCardComponent from "../../../components/InfoCardComponent";
import ActivationsCard from "./ActivationsCard";

//-------------------------------------------------------------------------------------------------- Interfaces
interface RenderAllActivationsProps {
    loading: boolean;
    hasError: boolean;
    activations: ResponsePackageActivation[];
    dataConf: {
        dataList: ConfigurableService[];
    };
};

//-------------------------------------------------------------------------------------------------- Component
const RenderAllActivationsCards = (props: RenderAllActivationsProps) => {
    const { loading, hasError, activations, dataConf } = props;
    // Control
    const [selected, setSelected] = useState<number | undefined>(undefined);

    const handlePressCard = (key: number) => {
        if (selected === key) {
            setSelected(undefined);
        }
        else {
            setSelected(key);
        }
    };

    return (
        <>
            {
                loading ?
                    <Loading />
                    : !_.isEmpty(activations) ?
                        <Row style={styles.cardsRow}>
                            {
                                activations.map((obj, key: number) => (
                                    <Col key={key} sm={24} xl={12} xxl={8}>
                                        <ActivationsCard
                                            id={key}
                                            activation={obj}
                                            selection={selected}
                                            onClick={() => handlePressCard(key)}
                                            dataConf={dataConf}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                        : hasError ?
                            <InfoCardComponent
                                color="#FFC439"
                                colorText="#000"
                                title="¡Estimado usuario!"
                                description={"Ocurrió un error al obtener los servicios. Intente de nuevo más tarde."}
                            />
                            :
                            <InfoCardComponent
                                color="#FFC439"
                                colorText="#000"
                                title="¡Estimado usuario!"
                                description={"No hay servicios para mostrar."}
                            />
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardsRow: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default RenderAllActivationsCards;
